import { actionCreatorFactory } from 'typescript-fsa'
import { Steper } from '../../types'

const actionCreator = actionCreatorFactory()

export const registerStepers = actionCreator<Steper[]>('registerStepers')
